import _classnames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../loader/loader';

/**
  A standard button element that requires the user to long press for 2 seconds to complete action.
  NOTE: This does NOT use the Holokit Button component.
*/
class DeleteButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleDeleteSims = null;
    this.state = {
      actionCompleted: false,
      clickInProgress: false,
      isLoading: false,
    };
  }

  handleButtonMouseDown = () => {
    const { disabled } = this.props;
    const { actionCompleted } = this.state;

    if (disabled) {
      return;
    }

    if (!actionCompleted) {
      this.handleDeleteSims = setTimeout(this.completeAction, 2000);
      this.setState({ clickInProgress: true });
    }
  };

  handleButtonClick = () => {
    const { disabled } = this.props;
    const { actionCompleted } = this.state;

    if (disabled) {
      return;
    }

    if (!actionCompleted) {
      clearTimeout(this.handleDeleteSims);
      this.setState({ clickInProgress: false });
    }
  };

  completeAction = () => {
    const { onSuccess } = this.props;

    this.setState(
      {
        clickInProgress: false,
        actionCompleted: true,
      },
      () => {
        setTimeout(() => {
          this.setState({ isLoading: true });
        }, 400);
      }
    );
    onSuccess();
  };

  render() {
    const { disabled, postActionText, text } = this.props;
    const { actionCompleted, clickInProgress, isLoading } = this.state;
    const displayText = postActionText && actionCompleted ? postActionText : text;

    return (
      <div
        className={_classnames('DeleteButton__container', {
          'DeleteButton__container--in-progress': clickInProgress,
        })}
      >
        {isLoading && <Loader isLoading />}
        <button
          className={_classnames('DeleteButton', {
            'DeleteButton--completed': actionCompleted,
            'DeleteButton--in-progress': clickInProgress,
          })}
          disabled={disabled}
          onClick={this.handleButtonClick}
          onContextMenu={this.handleButtonClick}
          onMouseDown={this.handleButtonMouseDown}
          type="button"
        >
          <span className="DeleteButton__text">{displayText}</span>
        </button>
      </div>
    );
  }
}

DeleteButton.propTypes = {
  disabled: PropTypes.bool,
  /**
    The button text after the click action has completed
  */
  postActionText: PropTypes.string,
  /**
    The function that runs after a successful long press
  */
  onSuccess: PropTypes.func,
  text: PropTypes.string,
};

DeleteButton.defaultProps = {
  disabled: false,
  postActionText: undefined,
  onSuccess: false,
  text: '',
};

export default DeleteButton;
